import React from 'react';
import i18n from '../../translate/i18n';

//COMPONENTS
import Template from '../../components/Template';
import TableOs from '../../components/TableOs';

export default function ListOs() {

  return (
    <Template path={i18n.t('menu.processes')}>
      <div className="position-relative p-3">
        <TableOs />
      </div>
    </Template>
  )
}
